"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

var _AddQuickLinkSection = require("./AddQuickLinkSection");

/* eslint-disable jsx-a11y/label-has-associated-control */
var CardStyleOptionBlock = function CardStyleOptionBlock(_ref) {
  var component = _ref.component,
      label = _ref.label,
      qaClassName = _ref.qaClassName;
  return (0, _preact.h)("div", {
    className: qaClassName
  }, component, (0, _preact.h)("div", null, label));
};

var CardStyleSelect = function CardStyleSelect(_ref2) {
  var onSelectedCardStyleChange = _ref2.onSelectedCardStyleChange,
      selectedCardStyle = _ref2.selectedCardStyle;

  var cardStyleOptions = _AddQuickLinkSection.CARD_STYLE_OPTIONS.map(function (_ref3) {
    var label = _ref3.label,
        component = _ref3.component,
        qaClassName = _ref3.qaClassName;
    return (0, _preact.h)(CardStyleOptionBlock, {
      key: label,
      label: label,
      component: component,
      qaClassName: qaClassName
    });
  });

  return (0, _preact.h)("div", {
    className: "quick-links-manager__add-quick-link-card-style"
  }, (0, _preact.h)("label", {
    className: "quick_links_common_settings_title"
  }, "Card Style"), (0, _preact.h)(_RadioInputGroup.default, {
    options: cardStyleOptions,
    onChange: function onChange(option, idx) {
      return onSelectedCardStyleChange(option, idx);
    },
    value: cardStyleOptions[selectedCardStyle]
  }));
};

var _default = CardStyleSelect;
exports.default = _default;